import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import Padding from 'hb-builder/components/common/SettingsLibrary/CommonSettings/Padding';
import Borders from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/CustomMode/ButtonStyle/Borders';
import { PADDING_INPUT_SET_TYPES } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/CustomMode/ButtonStyle/constants/paddings';
import { getDisplayedPaddingInputs } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/CustomMode/ButtonStyle/utils/paddings';
import Typography from 'hb-builder/components/common/SettingsLibrary/ComposedInputs/Typography';
import { useBuilderConfigContext } from 'hb-builder/hooks';

const CustomModeCommonSettings = ({
  item,
  settingProps: initialSettingProps,
}) => {
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();

  const buttons = item.children || [item];

  const settingProps = {
    ...initialSettingProps,
    defaultAttributes: buttons[0].attributes,
    item: buttons[0],
  };

  const colorSettingsProps = {
    color,
    networkColors,
    networkTheming,
  };

  const shouldForceUpdatePadding = ({ type }) =>
    type === 'top' || type === 'bottom';

  return (
    <div data-testid="custom-mode-common-settings">
      <Typography
        componentType="button"
        includeLineHeight={false}
        includeTextColor={false}
        {...settingProps}
      />
      <NumberSetting
        settingKey="buttonLetterSpacing"
        title={__('Character spacing')}
        {...settingProps}
      />
      <Padding
        needResetAlignment={false}
        settingKey="buttonPadding"
        title={__('Button paddings (in pixels)')}
        displayedInputs={getDisplayedPaddingInputs(
          PADDING_INPUT_SET_TYPES.VERTICAL,
        )}
        {...settingProps}
        shouldForceUpdateAllChildren={shouldForceUpdatePadding}
      />
      <Borders
        {...settingProps}
        {...colorSettingsProps}
        withoutColor
        displayTooltip
      />
    </div>
  );
};

export default CustomModeCommonSettings;
